module.exports = __webpack_public_path__ + "img/IMG_6070_L_BlackMatted.43095658.jpg";